module.exports = __webpack_public_path__ + "img/photo1_3.adb5b25d.jpg";